import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import moment from 'moment'
import { delay } from 'lodash'

import { Button, Glyphicon, Tooltip, OverlayTrigger } from 'react-bootstrap'

import { confirmModal } from 'actions/modal-actions'
import { fetchLatestSaveToDictionary, saveToDictionary } from 'actions/search-actions'
import { DAG_DICTIONARY_STATUS } from 'constants/constants'
import './save-to-dictionary.scss'

const DATE_SHORT_FORMAT = 'MMM DD'
const DATE_FORMAT = 'MM-DD-YYYY hh:mm:ss A'

class SaveToDictionary extends Component {
  componentDidMount() {
    this.refreshDagStatus()
  }

  refreshDagStatus = () => {
    this.props.fetchLatestSaveToDictionary()
  }

  openPublishModal = () => {
    const { confirmModal } = this.props

    confirmModal(
      <div>
        <p>
          <strong>
            <em>Are you sure you want to run Save Dictionary ?</em>
          </strong>
        </p>
      </div>,
      'Confirm Save Dictionary',
      { okButton: `Start Save Dictionary` },
      () => this.saveToDictionary()
    )
  }

  saveToDictionary = () => {
    this.props.saveToDictionary()
    delay(() => this.refreshDagStatus(), 2500)
  }

  getStatusText(text = 'undefined') {
    let color = ''
    switch (text) {
      case DAG_DICTIONARY_STATUS.QUEUED:
      case DAG_DICTIONARY_STATUS.DEFERRED:
      case DAG_DICTIONARY_STATUS.SCHEDULED:
      case DAG_DICTIONARY_STATUS.RUNNING:
        color = 'blue'
        break
      case DAG_DICTIONARY_STATUS.SUCCESS:
        color = 'green'
        break
      case DAG_DICTIONARY_STATUS.CANCELLED:
        color = 'yellow'
        break
      case DAG_DICTIONARY_STATUS.FAILED:
        color = 'red'
        break
      default:
        color = 'red'
    }

    return (
      <span className={`text-color-${color}`}>
        <strong>{text}</strong>
      </span>
    )
  }

  getTooltip(dagInfo) {
    return (
      <Tooltip id="save-to-dictionary-task-tooltip">
        <p>Click to refresh DAG information</p>
        {dagInfo && (
          <>
            <p>Last dag info:</p>
            <ul>
              <li>Run id: {dagInfo.dag_run_id}</li>
              <li>Status: {dagInfo.state}</li>
              <li>Create: {moment(dagInfo.execution_date).format(DATE_FORMAT)}</li>
              <li>Start: {dagInfo.start_date && moment(dagInfo.start_date).format(DATE_FORMAT)}</li>
              <li>End: {dagInfo.end_date && moment(dagInfo.end_date).format(DATE_FORMAT)}</li>
            </ul>
          </>
        )}
      </Tooltip>
    )
  }

  render() {
    const { hasEditAccess, latestSaveToDictionary } = this.props
    const status = latestSaveToDictionary.state || 'undefined'

    return (
      <div className="rightFormButton save-to-dictionary">
        {hasEditAccess && (
          <Button
            bsStyle="default"
            className="right"
            onClick={this.openPublishModal}
            disabled={
              status === DAG_DICTIONARY_STATUS.QUEUED ||
              status === DAG_DICTIONARY_STATUS.DEFERRED ||
              status === DAG_DICTIONARY_STATUS.SCHEDULED ||
              status === DAG_DICTIONARY_STATUS.RUNNING
            }
          >
            <Glyphicon glyph="cloud-upload" className="mr-2" />
            Save to Dictionary
          </Button>
        )}

        <div className="save-to-dictionary-status">
          <OverlayTrigger delayShow={100} placement="bottom" overlay={this.getTooltip(latestSaveToDictionary)}>
            <span
              title="Click to refresh DAG information"
              className="save-to-dictionary-text"
              onClick={this.refreshDagStatus}
            >
              Last run: {this.getStatusText(latestSaveToDictionary.state)}{' '}
              {latestSaveToDictionary && moment(latestSaveToDictionary.data_interval_end).format(DATE_SHORT_FORMAT)}
              <Glyphicon glyph="refresh" />
            </span>
          </OverlayTrigger>
        </div>
      </div>
    )
  }
}

SaveToDictionary.propTypes = {
  hasEditAccess: PropTypes.bool.isRequired,

  latestSaveToDictionary: PropTypes.object,
  fetchLatestSaveToDictionary: PropTypes.func,

  confirmModal: PropTypes.func,
  saveToDictionary: PropTypes.func
}

function mapStateToProps(state) {
  return {
    latestSaveToDictionary: state.search.latestSaveToDictionary
  }
}

const mapDispatchToProps = {
  confirmModal,
  fetchLatestSaveToDictionary,
  saveToDictionary
}

export default connect(mapStateToProps, mapDispatchToProps)(SaveToDictionary)
